<template>
  <EmptyResourceCard
    v-if="showNoConditions"
    :title="condition.capitalPlural"
    :button-text="`Add ${condition.capitalPlural}`"
    :description="condition.description"
    @button-click="showNoConditions = false"
  />

  <Card v-else class="mb-0">
    <CardHeader>
      <CardTitle>
        {{ condition.capitalPlural }}
        <HelpTooltip :description="condition.description" />
      </CardTitle>
    </CardHeader>
    <CardContent>
      <ConditionExpressionList />
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ref } from 'vue';
import EmptyResourceCard from '../common/EmptyResourceCard.vue';
import ConditionExpressionList from './ConditionExpressionList.vue';
import type { UseWorkflowConditionEditorReturn } from './useWorkflowConditionEditor';
import { useWorkflowConditionEditorProvider } from './useWorkflowConditionEditorProvider';
import HelpTooltip from '../common/HelpTooltip.vue';
import { useConditionDisplay } from './useConditionDisplay';

type ConditionCardProps = {
  editor: UseWorkflowConditionEditorReturn;
};
const props = defineProps<ConditionCardProps>();

const { conditionDisplay } = useConditionDisplay();

const { provideEditor } = useWorkflowConditionEditorProvider();
provideEditor(props.editor);

const condition = conditionDisplay(props.editor.type);

const showNoConditions = ref<boolean>(props.editor.isConditionNew.value);
</script>
